<template>
  <div style="width: 100% ;box-sizing: border-box;background: rgba(12,11,11,0.50);" ref="box">
    <div class="header" ref="header">
      <div class="left" ref="left">
        <div class="logo2" ref="logo"></div>
        <div class="line" ref="line"></div>
        <div class="text">招贤纳士</div>
      </div>

      <ul class="right" ref="right">
        <li>
          <!--          <a href="http://ahwater.net/about" target="_blank">招聘首页</a>-->
          <router-link to="/zpindex">招聘首页</router-link>
        </li>
        <li>
          <router-link to="/shzp">招聘信息</router-link>
        </li>
        <li>
          <!--          <router-link to="/zpindex">首页</router-link>-->
          <a href="http://ahwater.net/" target="_blank">官网首页</a>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerBlack",
  components: {},
  data() {
    return {}
  },
  created() {
  },
  methods: {},
}
</script>

<style scoped>

.header {
  width: 1200px;
  height: 80px;
  margin: 0px auto;
  /*background-color: transparent;*/
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 10px;
  font-family: normal;
  /*background-color: white;*/

}

.left {
  height: 35px;
  width: auto;
  /*background-color: gray;*/
  display: flex;
  align-items: flex-end;
  color: #FFFFFF;
}


.logo2 {
  width: 228px;
  height: 35px;
  background-image: url("/src/assets/img/沃特水务LOGO-白色.png");
  background-size: 100% 100%;
  /*background: transparent;*/
}

.line {
  width: 1px;
  height: 22px;
  /*border: 1px solid #666666;*/
  margin-left: 11.5px;
  margin-right: 12.5px;
  background-color: #666666;
}

.text {
  height: 23px;
  font-size: 18px;

}

.right {
  height: 18px;
  font-size: 18px;
  color: #999999;
  position: relative;
}

.right li {
  float: right;
  margin-left: 79px;
  font-weight: Normal;
  position: relative;
}

.router-link-active:after {
  content: '';
  position: absolute;
  bottom: -22px;
  right: auto;
  left: calc(50% - 15.5px);
  height: 4px;
  width: 31px;
  background-color: #3772D3;

}


a:-webkit-any-link {
  color: #999999;
  user-select: none;
}


.router-link-active {
  color: #ffffff !important;

}


</style>